import UserAddressCardRadio from 'domains/user/organisms/address-card-radio'
import { Alert, Button, Modal, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const propTypes = {
  toggle              : PropTypes.func,
  isModalOpen         : PropTypes.boolean,
  userId              : PropTypes.number,
  addresses           : PropTypes.array,
  selectedAddress     : PropTypes.object,
  handleSelectAddress : PropTypes.func
}

const UserAddressModal = ({
  toggle,
  isModalOpen,
  userId,
  addresses,
  selectedAddress,
  handleSelectAddress
}) => {

  const Header = () => (
    <div className='d-flex align-items-center mb-4'>
      <i className='fas fa-chevron-left'
        onClick={ () => toggle() }
      />
    </div>
  )

  const CheckoutAddressList = () => {
    if (addresses.length === 0) {
      return <Alert color='info'><i className='fas fa-info-circle mr-2'/>You have no addresses saved.</Alert>
    }
    else {
      return (
        addresses.map((address) => (
          <UserAddressCardRadio
            key={ `checkout-address-card-radio-${address.id}` }
            address={ address }
            isSelected={ selectedAddress.id == address.id }
            handleSelect={ handleSelectAddress }
          />
        ))
      )
    }
  }

  return (
    <Modal
      scrollable
      centered
      isOpen={ isModalOpen }
      toggle={ () => toggle(!isModalOpen) }
      className='mx-auto my-auto'
    >
      <ModalBody>
        <Header />
        <div className='d-flex align-items-center justify-content-between mb-3'>
          <h4 className='my-0'>Addresses</h4>
          <Button
            size='sm'
            color='success'
            tag={ Link }
            to={ `/app/users/${userId}/addresses/create` }
          >
            { 'Create Address' }
          </Button>
        </div>
        <CheckoutAddressList/>
      </ModalBody>
    </Modal>
  )
}

UserAddressModal.propTypes = propTypes

export default UserAddressModal
